import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';
import { geraFiltroHttp } from '../util/functions';

class MensagemService extends BaseService {
  constructor() {
    super(`${ConfigApi.mensagemURL}`);
    this.lookupConfig = new LookupConfig();
    this.lookupConfig.serviceInstance = this;
  }

  getFilter() {
    return new Filter();
  }

  getLookupConfig(handleConfirm, handleCancel = undefined) {
    this.lookupConfig.handleConfirm = handleConfirm;
    this.lookupConfig.handleCancel = handleCancel;
    return this.lookupConfig;
  }

  async findLookup(filter) {
    this.setLoading(true);
    try {
      const filterGet = geraFiltroHttp(filter);
      const response = await this.api.get(`messagensChatIds/${filterGet}`);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.login = '';
    this.idColaborador = undefined;
    this.limit = 11;
    this.page = 0;
  }
}

class LookupConfig {
  constructor() {
    this.serviceInstance = null;
    this.title = 'Localiza';
    this.defaultFilter = 'nome';
    this.handleConfirm = _record => {};
    this.filters = [];
    this.columns = [
      {
        name: 'chatId',
        caption: 'ChatId',
        width: 100,
        cssClassName: 'grid-col-id',
      },
      {
        name: 'firstName',
        caption: 'Nome',
      },
      {
        name: 'userName',
        caption: 'User Name',
      },
      // {
      //   name: 'date',
      //   caption: 'Data/Hora',
      //   width: 130,
      //   handleFormatValue: value => {
      //     return formatDate(value, 'yyyy-MM-dd HH:mm');
      //   },
      // },
      // {
      //   name: 'mensagem',
      //   caption: 'Mensagem',
      // },
    ];
  }
}
export default new MensagemService();
